import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddUserLanguage1700174789690 implements MigrationInterface {
	name = 'AddUserLanguage1700174789690'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "user" ADD "preferedLanguage" character varying(3)`)
		await queryRunner.query(
			`ALTER TABLE "table_token" ALTER COLUMN "token" SET DEFAULT substr(md5(''||now()::text||random()::text), 0, 16)`,
		)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(
			`ALTER TABLE "table_token" ALTER COLUMN "token" SET DEFAULT substr(md5(((''|| (now())) || (random()))), 0, 16)`,
		)
		await queryRunner.query(`ALTER TABLE "user" DROP COLUMN "preferedLanguage"`)
	}
}
